import { render, staticRenderFns } from "./AComponents.vue?vue&type=template&id=710676da"
import script from "./AComponents.vue?vue&type=script&lang=js"
export * from "./AComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports